import React from 'react';
import PropTypes from 'prop-types';
import FilterCategory from './FilterCategory';
import FilterMonetize from './FilterMonetize';
import BulkActions from './BulkActions';
import styles from './ContentActions.module.css';

const ContentActions = ({
  setSelectedCategory,
  selectedCategory,
  setSelectedMonetizeType,
  selectedMonetizeType,
  categories,
  setArticles,
}) => (
  <div className={styles.content__actions}>
    <span className={styles['content__actions-tag']}>Posts</span>
    <FilterCategory
      selectedCategory={selectedCategory}
      setSelectedCategory={setSelectedCategory}
      categories={categories}
    />
    <FilterMonetize
      setSelectedCategory={setSelectedCategory}
      setSelectedMonetizeType={setSelectedMonetizeType}
      selectedMonetizeType={selectedMonetizeType}
    />
    <BulkActions
      selectedCategory={selectedCategory}
      setArticles={setArticles}
    />
  </div>
);

ContentActions.propTypes = {
  categories: PropTypes.node.isRequired,
  selectedCategory: PropTypes.node.isRequired,
  setSelectedCategory: PropTypes.node.isRequired,
  selectedMonetizeType: PropTypes.node.isRequired,
  setSelectedMonetizeType: PropTypes.node.isRequired,
  setArticles: PropTypes.node.isRequired,
};

export default ContentActions;
